<template>
    <div class="form-group">
        <lt-label
            :label="label"
            :popper-content="popperContent"
            :show-tooltip="showTooltip"
            :show-question-mark="showQuestionMark"
            :tooltip-link="tooltipLink"
        />
        <span class="small-text">{{ smalltext }}</span>
        <select
            v-if="setSelected"
            ref="input"
            :value="value"
            :class="classValue"
            :v-model="Value"
            @change="updateValue($event.target.value)">
            <!-- Added for iOS compatibility -->
            <option
                disabled
                value="">
                {{ DefaultOption }}
            </option>
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="option.value"
                :selected="option.value == Value">
                {{ option.text }}
            </option>
        </select>
        <select
            v-else
            ref="input"
            :value="value"
            :class="classValue"
            @change="updateValue($event.target.value)">
            <option
                v-for="(option, index) in options"
                :key="`${index}-${option.value}`"
                :value="option.value">
                {{ option.text }}
            </option>
        </select>
    </div>
</template>
<script>
    import LtLabel from '~/components/lt-label.vue';
    import trackData from '~/mixin/track-data';

    export default {
        components: {
            LtLabel,
        },
        mixins: [trackData],
        props: {
            value: {
                default: 0,
            },
            label: {
                type: String,
                default: '',
            },
            options: {
                default() {
                    return [];
                },
            },
            tooltipLink: {
                type: String,
                default: '',
            },
            classValue: {
                type: String,
                default: '',
            },
            smalltext: {
                type: String,
                default: '',
            },
            showTooltip: {
                default: false,
            },
            showQuestionMark: {
                default: '',
            },
            popperContent: {
                default: '',
            },
            setSelected: {
                default: false,
            },
            defaultOption: {
                default: 'Please select one',
            },
        },
        data() {
            return {
                Value: this.value,
                DefaultOption: this.defaultOption,
            };
        },
        watch: {
            value(newValue, oldValue) {
                this.Value = newValue;
            },
        },
        mounted() {
            this.formatValue();
            this.setTracking();
        },
        updated() {
            this.setTracking();
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
            formatValue() {
                this.$refs.input.value = this.value;
            },
            setTracking() {
                trackData.set({ key: this.label, val: this.value });
            },
        },
    };
</script>
